/**
 * Animation Timing Constants
 *
 * Platform-specific timing and easing curves based on:
 * - iOS Human Interface Guidelines
 * - Material Design Motion Guidelines
 * - Web fallback (matches iOS for consistency)
 *
 * @see https://developer.apple.com/design/human-interface-guidelines/animations
 * @see https://m3.material.io/styles/motion/easing-and-duration/tokens-specs
 */

/**
 * iOS Animation Timing
 * Based on iOS Human Interface Guidelines
 */
export const IOS_TIMING = {
  DURATION: 400,
  EASING: 'cubic-bezier(0.32, 0.72, 0.0, 1.0)',
};

/**
 * Android Animation Timing
 * Based on Material Design Motion Guidelines
 */
export const ANDROID_TIMING = {
  DURATION: 300,
  EASING: 'cubic-bezier(0.2, 0.0, 0.0, 1.0)',
};

/**
 * Web Animation Timing
 * Uses iOS timing for consistency with app's iOS-first design
 */
export const WEB_TIMING = {
  DURATION: 350,
  EASING: 'ease-in-out',
};

/**
 * Get timing constants for a specific platform
 *
 * @param {string} platform - Platform: 'ios' | 'android' | 'web'
 * @returns {Object} Timing constants with duration and easing
 */
export function getTimingForPlatform(platform) {
  switch (platform) {
    case 'ios':
      return IOS_TIMING;
    case 'android':
      return ANDROID_TIMING;
    case 'web':
      return WEB_TIMING;
    default:
      return WEB_TIMING;
  }
}

/**
 * Complete timing registry
 */
export const TIMING = {
  ios: IOS_TIMING,
  android: ANDROID_TIMING,
  web: WEB_TIMING,
};
